import React from "react";

const BarChart = ({ data, labels, title }) => {
    const maxValue = Math.max(...data, 100);

    return (
        <div className="w-full px-2 flex flex-col h-full">
            {/* Chart Area */}
            <div className="flex w-full h-full">
                {/* Y-axis */}
                <div className="flex flex-col justify-between pr-2 text-right text-[10px] sm:text-sm text-gray-500 flex-shrink-0">
                    <div>100%</div>
                    <div>75%</div>
                    <div>50%</div>
                    <div>25%</div>
                    <div>0%</div>
                </div>

                {/* Bars */}
                <div className="flex flex-1 justify-between border-l border-gray-800 border-b pb-2">
                    {data.map((value, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center justify-end flex-1"
                        >
                            <div className="flex items-end justify-center h-full w-full">
                                <div
                                    className="bg-[#7451f8] rounded-t transition-all duration-500 hover:bg-[#5b3ed6] relative w-[60%] sm:w-[55%] lg:w-[50%]"
                                    style={{
                                        height: `${Math.max((value / maxValue) * 100, 5)}%`,
                                    }}
                                >
                                    {/* Percentage Label */}
                                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-[9px] sm:text-xs font-medium whitespace-nowrap">
                                        {value}%
                                    </div>
                                </div>
                            </div>
                            {/* X-axis Label with fixed height on mobile */}
                            <div className="mt-1 text-[9px] sm:text-xs text-gray-900 text-center leading-tight min-h-[22px] sm:min-h-0 flex items-center justify-center">
                                {labels[index]}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Title */}
            {title && (
                <h4 className="mt-6 mb-6 text-center text-gray-600 text-sm sm:text-lg font-medium">
                    {title}
                </h4>
            )}
        </div>
    );
};

export default BarChart;
